import api, { handleApiResponse, handleApiError } from './api';

class UserService {
  // Get all users
  async getUsers(params = {}) {
    try {
      const response = await api.get('/users', { params });
      return handleApiResponse(response);
    } catch (error) {
      throw new Error(handleApiError(error));
    }
  }

  // Get single user
  async getUser(id) {
    try {
      const response = await api.get(`/users/${id}`);
      return handleApiResponse(response);
    } catch (error) {
      throw new Error(handleApiError(error));
    }
  }

  // Create user
  async createUser(data) {
    try {
      const response = await api.post('/users', data);
      return handleApiResponse(response);
    } catch (error) {
      throw new Error(handleApiError(error));
    }
  }

  // Update user
  async updateUser(id, data) {
    try {
      const response = await api.put(`/users/${id}`, data);
      return handleApiResponse(response);
    } catch (error) {
      throw new Error(handleApiError(error));
    }
  }

  // Delete user
  async deleteUser(id) {
    try {
      const response = await api.delete(`/users/${id}`);
      return handleApiResponse(response);
    } catch (error) {
      throw new Error(handleApiError(error));
    }
  }

  // Search users (customers for customer care)
  async searchCustomers(query) {
    try {
      const response = await api.get('/customers/search', {
        params: { search: query }
      });
      return handleApiResponse(response);
    } catch (error) {
      throw new Error(handleApiError(error));
    }
  }

  // Get user types
  getUserTypes() {
    return [
      { value: 'customer', label: 'Customer' },
      { value: 'staff', label: 'Staff' },
      { value: 'admin', label: 'Administrator' }
    ];
  }

  // Get staff levels
  getStaffLevels() {
    return [
      { value: 1, label: 'Level 1' },
      { value: 2, label: 'Level 2' },
      { value: 3, label: 'Level 3' }
    ];
  }

  // Format user display name
  formatUserDisplayName(user) {
    if (!user) return 'Unknown User';
    return user.name || user.username || user.email || 'Unknown User';
  }

  // Get user avatar initials
  getUserInitials(user) {
    if (!user) return 'U';
    const name = user.name || user.username || user.email || 'User';
    return name.charAt(0).toUpperCase();
  }

  // Validate user data
  validateUserData(data, isUpdate = false) {
    const errors = {};

    if (!isUpdate || data.name !== undefined) {
      if (!data.name?.trim()) {
        errors.name = 'Name is required';
      }
    }

    if (!isUpdate || data.email !== undefined) {
      if (!data.email?.trim()) {
        errors.email = 'Email is required';
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
        errors.email = 'Invalid email format';
      }
    }

    if (!isUpdate && !data.password) {
      errors.password = 'Password is required';
    } else if (data.password && data.password.length < 6) {
      errors.password = 'Password must be at least 6 characters';
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors
    };
  }
}

export default new UserService();